import React from 'react'

import { IconProps, iconClassName, iconColor } from './IconProps'

export const MoneyNoteIcon: React.FC<IconProps> = (props) => {
  const { size = 24, width, height, onClick, strokeWidth = 2, ...rest } = props

  return (
    <svg
      width={width || size}
      height={height || size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={iconClassName(props)}
      onClick={onClick}
      {...rest}
    >
      <path
        d='M2 17.6869C9.27273 13.1376 14.7273 22.236 22 17.6867V6.31345C14.7273 10.8628 9.27273 1.76394 2 6.31325V17.6869Z'
        stroke={iconColor(props)}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.4088 10.5859C12.629 9.80468 11.3654 9.80468 10.5856 10.5859C9.80479 11.3682 9.80479 12.6373 10.5856 13.4196C11.3654 14.2009 12.629 14.2009 13.4088 13.4196C14.1896 12.6373 14.1896 11.3682 13.4088 10.5859Z'
        stroke={iconColor(props)}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5 8.5V13.5'
        stroke={iconColor(props)}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
      <path
        d='M19 10V15'
        stroke={iconColor(props)}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
    </svg>
  )
}
